// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/methods/firstparty/v1/deactivate_method.proto

/* oxlint-disable */
import { ApiMethod } from "./common";

/** Request message to deactivate a payment method. */
export interface ApiDeactivateMethodRequest {
  /** Unique identifier of the method to deactivate. */
  readonly id: string;
}

/** Response message after deactivating a payment method. */
export interface ApiDeactivateMethodResponse {
  /** The deactivated payment method details. */
  readonly method: ApiMethod | null;
}

export const ApiDeactivateMethodRequest: MessageFns<ApiDeactivateMethodRequest> = {
  fromJSON(object: any): ApiDeactivateMethodRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiDeactivateMethodRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiDeactivateMethodResponse: MessageFns<ApiDeactivateMethodResponse> = {
  fromJSON(object: any): ApiDeactivateMethodResponse {
    return { method: isSet(object.method) ? ApiMethod.fromJSON(object.method) : null };
  },

  toJSON(message: ApiDeactivateMethodResponse): unknown {
    const obj: any = {};
    if (message.method !== undefined && message.method !== null) {
      obj.method = ApiMethod.toJSON(message.method);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
